module.exports = "<div class=\"row\">\n    <div class=\"col-md-5 col-lg-5\">\n        <drop-file [label]=\"fileIndicationLabel\" [disable]=\"disabled\" (files)=\"dropFilesHandler($event)\" [limit]=\"config.maxFilesize * 1000000\"></drop-file>\n    </div>\n    <div class=\"col-md-7 col-lg-7\">\n        <app-image-list-modal [canDelete]=\"canDelete\" (deleted)=\"deleteFile($event)\"></app-image-list-modal>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/drop-image-list-modal/drop-image-list-modal.component.html
// module id = ../../../../../src/app/shared/drop-image-list-modal/drop-image-list-modal.component.html
// module chunks = main